import { Button } from '@mui/material'
import { Moment } from 'moment'

export interface DaySwitcherProps {
  selectedDay: Moment
  dayOffset: number
  roundStartDay: Moment
  onGoBackADay: () => void
  onGoForwardADay: () => void
}

const MAX_OFFSET = 1

export const DaySwitchers = ({
  selectedDay,
  dayOffset,
  roundStartDay,
  onGoBackADay,
  onGoForwardADay,
}: DaySwitcherProps) => {
  return (
    <div>
      <Button
        variant="text"
        onClick={onGoBackADay}
        disabled={
          dayOffset === MAX_OFFSET ||
          selectedDay.clone().subtract(1, 'days').isBefore(roundStartDay, 'day')
        }
      >
        {dayOffset === 0
          ? 'Go to yesterday'
          : dayOffset > 0 && dayOffset < MAX_OFFSET
          ? `Go to ${selectedDay.clone().subtract(1, 'days').format('ddd')}`
          : "Can't go back"}
      </Button>
      <Button
        variant="text"
        onClick={onGoForwardADay}
        disabled={dayOffset === 0}
      >
        {dayOffset === 0
          ? "Can't go forward"
          : dayOffset === 1
          ? `Back to today`
          : `Go to ${selectedDay.clone().add(1, 'days').format('ddd')}`}
      </Button>
    </div>
  )
}
